import { render, staticRenderFns } from "./TabArbo.vue?vue&type=template&id=9b9d3bf0&"
import script from "./TabArbo.vue?vue&type=script&lang=js&"
export * from "./TabArbo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports